<template>
  <el-dialog
    title="避难场所人员登记名单"
    :visible.sync="dialogVisible"
    width="1200px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <common-table
        :select="false"
        :page="page"
        :dataList="dataList"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
      </common-table>
    </div>
  </el-dialog>
</template>
<script>
import { registerList } from "@/api/crashInfo.js";
import commonTable from "@/components/table/index.vue";
export default {
  components: {
    commonTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "name",
            label: "姓名"
          },
          {
            prop: "idCard",
            label: "身份证号"
          },
          {
            prop: "phone",
            label: "手机"
          },
          {
            prop: "registrationTime",
            label: "登记时间"
          }
        ]
      }
    };
  },
  mounted() {
    this.registerListFun();
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val;
      this.registerListFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.registerListFun();
    },
    // 分页查询
    async registerListFun() {
      let params = {
        page: this.page.page,
        size: this.page.size,
        pointId: this.curItem.pointId
      };
      const res = await registerList(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

.container-dialog {
  position: relative;
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/crashInfo/asylumSeekers/components/addDialog.vue